export enum PaymentTypes {
	Card = 'card',
	ACH = 'ach'
}
